module.exports = __webpack_public_path__ + "img/spedy.edde72c6.svg";